/**
 * ⚠️ LR DIRECT FORK — do not merge into marketplace hooks.
 *
 * Aggregate-only shipper activity for the broker bid panel.
 * Calls a SECURITY DEFINER RPC that returns NUMBERS ONLY — no shipper name,
 * company, or any identifying field — so blind (open-market) bidding stays blind.
 */

import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface DirectShipperActivity {
  activeLoads: number;
  totalLoads: number;
  quotesPosted: number;
  verified: boolean;
}

export function useDirectShipperActivity(loadId: string | null | undefined) {
  return useQuery({
    queryKey: ["direct-shipper-activity", loadId],
    enabled: !!loadId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    queryFn: async (): Promise<DirectShipperActivity | null> => {
      const { data, error } = await supabase.rpc("get_direct_shipper_activity", {
        _load_id: loadId,
      });
      if (error) throw error;
      const row = Array.isArray(data) ? data[0] : data;
      if (!row) return null;
      return {
        activeLoads: Number((row as any).active_loads ?? 0),
        totalLoads: Number((row as any).total_loads ?? 0),
        quotesPosted: Number((row as any).quotes_posted ?? 0),
        verified: !!(row as any).shipper_verified,
      };
    },
  });
}
